<template>
  <!-- 产品 author: zhangxiaofeng  -->
  <p :class="['flex package-instance', 'level-' + level, isLeaf ? 'instance' : '', borderTop ? 'border-top' : '']">
    <span class="w-410 ellipsis inline-block flex-1">
      <i v-if="!isLeaf" class="r2-icon-nav_chevron_right color-default"
         :style="{transform: fold ? 'rotate(0deg)' : 'rotate(90deg)', fontSize: '18px',paddingBottom: '2px'}"
         @click="triggerFold"></i>
      <label :class="{highlight: searchCondition.includes(item.productName)}"
             @click="triggerFold">{{item.productName || item.merchandiseName}}</label>
    </span>
    <span style="width:264px;padding-left: 20px"
          :class="['w-199', forever ? 'font-right' : '']">{{item | formatLimit}}</span>
  </p>
</template>
<style lang="less" type="text/less" scoped>
  .package-instance {
    margin-bottom: 0;
    border-bottom: 1px solid #e6e6e6;
    span.w-410 {
      .highlight {
        padding: 2px 5px;
        padding-left: 10px;
      }
    }

    &.level-1 {
      // padding: 4px 0 5px 0;
      span.w-410 {
        padding-left: 16px;

        & > i, & > label {
          cursor: pointer;
        }

        i {
          left: -2px;
        }
      }

      &.instance {
        span.w-410 {
          padding-left: 16px;
        }
      }
    }

    &.level-2 {
      // padding: 4px 0 5px 0;
      span.w-410 {
        padding-left: 32px;

        & > i, & > label {
          cursor: pointer;
        }

        i {
          left: 10px;
          // padding-left: 11px
        }
      }
    }

    &.level-3 {
      // padding: 4px 0 5px 0;
      span.w-410 {
        padding-left: 48px;

        & > i, & > label {
          cursor: pointer;
          /*padding-left: 12px;*/
        }

        i {
          left: 34px;
        }
      }
    }

    &.level-4 {
      // padding: 4px 0 5px 0;
      span.w-410 {
        padding-left: 36px;

        & > i, & > label {
          cursor: pointer;
          /*padding-left: 24px;*/
        }

        i {
          left: 52px;
        }
      }
    }

    &.instance {
      span.w-199 {
        visibility: visible;
      }

      line-height: 35px;
      border-bottom: 1px solid #e6e6e6;

      span.w-410 {
        & > i, & > label {
          cursor: default !important;
        }
      }

      &.border-top {
        border-top: 1px solid #e6e6e6;
        padding-top: -1px;
      }
    }

    .t-head {
      span.w-410 {
        // padding-left: 5px;
      }
    }

    span {
      display: inline-block;
      height: 100%;
      box-sizing: border-box;
      float: left;
      font-size: 14px;

      &.w-410 {
        font-size: 14px;
        // width: 410px;
        // padding-right: 5px;
        height: 35px;
        line-height: 35px;

        i {
          // position: absolute;
          display: inline-block;
          font-size: 26px;
        }

        label {
          color: rgba(33, 37, 48, 0.8);
        }
      }

      &.w-199 {
        color: rgba(33, 37, 48, 0.8);
        font-size: 12px;
        /*width: 199px;*/
        padding: 0 5px;
        visibility: hidden;

        &.show {
          visibility: visible !important;
        }
      }

      &.font-right {
        text-align: right;
      }
    }
  }
</style>
<script>
import {parseTime} from '@/assets/utils'

export default {
  name: 'PackageInstance',
  props: {
    isLeaf: { // 叶子节点
      type: Boolean,
      default: true
    },
    borderTop: {
      type: Boolean,
      default: false
    },
    level: { // 当前是第几级
      type: Number,
      default: 1
    },
    item: {
      type: Object,
      default: () => {
      }
    },
    searchCondition: { // 产品名称过滤条件
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      fold: true // 菜单是否折叠
    }
  },
  computed: {
    forever () {
      let result = false
      if (this.item.limitEndTime === null && this.item.limitStartTime === null) {
        result = true
      }
      return result
    }
  },
  filters: {
    formatLimit (item) {
      let str = ''
      if (item.limitEndTime === null && item.limitStartTime === null) {
        str = '永久'
      } else {
        if (/^\d+$/g.test(item.limitEndTime) && /^\d+$/g.test(item.limitStartTime)) {
          str = '有效期：' + parseTime(item.limitStartTime, '{y}-{m}-{d}') + '~' + parseTime(item.limitEndTime, '{y}-{m}-{d}')
        }
      }
      return str
    }
  },
  methods: {
    triggerFold () {
      if (!this.isLeaf) {
        this.fold = !this.fold
        this.$nextTick(() => {
          this.$emit('foldHandle', this.fold)
        })
      }
    }
  }
}
</script>
